var panel = {
    group: 'block',
    content: '(paragraph | heading | bulletList | orderedList | blockCard)+',
    attrs: {
        panelType: { default: 'info' },
    },
    parseDOM: [
        {
            tag: 'div[data-panel-type]',
            getAttrs: function (dom) { return ({
                panelType: dom.getAttribute('data-panel-type'),
            }); },
        },
    ],
    toDOM: function (node) {
        var panelType = node.attrs['panelType'];
        var attrs = {
            'data-panel-type': panelType,
        };
        return ['div', attrs, ['div', {}, 0]];
    },
};

export { panel };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/panel.js